export const lenisStore = { current: null };

export const scrollToTarget = (target) => {
    if (lenisStore.current) {
        lenisStore.current.scrollTo(target, { offset: -90, duration: 1.4 });
    }
};
